
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12.6","height":"11.667","viewBox":"0 0 12.6 11.667","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.3 0a.9.9 0 00-.9.9V5H.833a.833.833 0 000 1.667H5.4v4.1a.9.9 0 001.8 0v-4.1h4.567a.833.833 0 000-1.667H7.2V.9a.9.9 0 00-.9-.9z","clip-rule":"evenodd","fill":"#55585e","fill-rule":"evenodd"}})])
          )
        }
      }
    